import React from "react";
import { TrendBrickChart, periodsFromRows } from "./TrendBrickChart";

// Proficiency tiers, top-to-bottom. Keys are the Teacher and School views'
// count columns. WIP (fewer than 5 answers) is not drawn; it stays in the
// table and the CSV.
const TIERS = [
  { key: "level_3_count", color: "#00A35A", short: "Lv3", name: "Ready to Lead" },
  { key: "level_2_count", color: "#EAB308", short: "Lv2", name: "Needs Practice" },
  { key: "level_1_count", color: "#FE1E7E", short: "Lv1", name: "Needs Support" },
];

/**
 * Level counts per period, summed across the View By entities. Each brick is
 * one (student, standard) pair at that level, which is what the Teacher and
 * School rows count. The graph is hidden at student grain, where the rows
 * carry no counts.
 */
export const ProficiencyTrendChart = ({ rows, trendBy }) => (
  <TrendBrickChart
    title="Proficiency Trend"
    yLabel="Student-Standard Count"
    tiers={TIERS}
    periods={periodsFromRows(rows, trendBy, TIERS, (row, key) => row[key] || 0)}
  />
);
